import React from 'react';
import { Outlet, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { FiGrid, FiMap, FiClock, FiFileText, FiLogOut, FiUser } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

const font = "'Outfit', sans-serif";
const BL = '#6366f1';
const C = { bg: '#eef2ff', sidebar: '#312e81', text: '#1e1b4b', white: '#fff', border: '#e0e7ff' };

const HallManagerLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, logout: authLogout } = useAuth();

    // Check auth
    const token = sessionStorage.getItem('exam_portal_token');

    if (!token || !user || user.role !== 'hall_manager') {
        return <Navigate to="/login" replace />;
    }

    const logout = () => {
        authLogout();
        navigate('/login');
    };

    const links = [
        { path: '/hall-manager/dashboard', icon: <FiGrid size={18} />, label: 'Dashboard' },
        { path: '/hall-manager/halls', icon: <FiMap size={18} />, label: 'Manage Halls' },
        { path: '/hall-manager/allocations', icon: <FiUser size={18} />, label: 'Hall Allocations' },
        { path: '/hall-manager/supply-exams', icon: <FiClock size={18} />, label: 'Supply Exams' },
        { path: '/hall-manager/review-papers', icon: <FiFileText size={18} />, label: 'Review Papers' },
    ];

    return (
        <div style={{ display: 'flex', height: '100vh', width: '100vw', background: C.bg, fontFamily: font, overflow: 'hidden' }}>
            {/* Sidebar */}
            <div style={{ width: 260, background: C.sidebar, color: '#fff', display: 'flex', flexDirection: 'column', padding: '24px 0', borderRight: `1px solid rgba(255,255,255,0.1)`, zIndex: 10 }}>
                {/* Logo Area */}
                <div style={{ padding: '0 24px', marginBottom: 30, display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 40, height: 40, borderRadius: 10, background: 'linear-gradient(135deg, #818cf8, #6366f1)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(99,102,241,0.4)', color: '#fff' }}>
                        <FiGrid size={22} />
                    </div>
                    <div>
                        <h2 style={{ fontSize: 16, fontWeight: 900, margin: 0, letterSpacing: 0.5 }}>SVU Exam</h2>
                        <span style={{ fontSize: 11, color: '#a5b4fc', fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase' }}>Hall Manager</span>
                    </div>
                </div>

                {/* Nav Links */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, padding: '0 16px', flex: 1 }}>
                    {links.map(l => {
                        const act = location.pathname.startsWith(l.path);
                        return (
                            <button key={l.path} onClick={() => navigate(l.path)} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: act ? 'rgba(255,255,255,0.1)' : 'transparent', border: 'none', borderRadius: 12, color: act ? '#fff' : '#c7d2fe', fontSize: 13, fontWeight: act ? 800 : 600, cursor: 'pointer', transition: 'all 0.2s ease', fontFamily: font, textAlign: 'left' }}>
                                <span style={{ color: act ? '#818cf8' : '#818cf8', opacity: act ? 1 : 0.7 }}>{l.icon}</span>
                                {l.label}
                            </button>
                        );
                    })}
                </div>

                {/* Bottom User Area */}
                <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: 'auto' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                        <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#4f46e5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 800, border: '2px solid rgba(255,255,255,0.2)' }}>
                            {user.name?.charAt(0) || 'H'}
                        </div>
                        <div style={{ overflow: 'hidden' }}>
                            <div style={{ fontSize: 13, fontWeight: 800, color: '#fff', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{user.name}</div>
                            <div style={{ fontSize: 10, color: '#a5b4fc', fontWeight: 600 }}>{user.username}</div>
                        </div>
                    </div>
                    <button onClick={logout} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '10px', background: 'rgba(239,68,68,0.1)', color: '#fca5a5', border: 'none', borderRadius: 10, fontSize: 12, fontWeight: 700, cursor: 'pointer', transition: 'all 0.2s', fontFamily: font }}>
                        <FiLogOut size={14} /> Logout
                    </button>
                </div>
            </div>

            {/* Main Content Area */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
                <div style={{ flex: 1, overflowY: 'auto', padding: '30px 40px' }}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default HallManagerLayout;
